import { getCardBrand } from './createClientCard';

export const extractCardDetails = ({ cardNumber = '', cardExpiration = '' }) => {
  const cleanCardNumber = cardNumber.replace(/\D/g, '');
  const expirationDigits = cardExpiration.replace(/\D/g, '');
  const expMonth = expirationDigits.substring(0, 2);
  const expYearShort = expirationDigits.substring(2, 4);
  const expYear = expYearShort.length === 2 ? `20${expYearShort}` : expYearShort;

  return {
    cleanCardNumber,
    firstDigits: cleanCardNumber.slice(0, 6),
    lastDigits: cleanCardNumber.slice(-4),
    expMonth,
    expYearShort,
    expYear,
    expirationDate: `${expMonth}/${expYearShort}`,
    brand: getCardBrand(cleanCardNumber),
  };
};
